import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from 'react-select';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { downloadFW_ListingPDF } from "./DownloadFWListingPDF";

const Rpt_FeeWaiverListing = () => {

  const [selectedStd, setSelectedStd] = useState();
  const [ddlStds, setDdlStds] = useState([]);
  const [selectedDiv, setSelectedDiv] = useState();
  const [ddlDivisions, setDdlDivisions] = useState([]);

  const [selectedYear1, setSelectedYear1] = useState();
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);

  const [reportData, setReportData] = useState([]);

  useEffect(() => {

    loadDropdowns();

  }, []);

  const loadDropdowns = async () => {
    try {

      const std = await axios.get(`${BASE_URL}/api/ddl_all_standards`);
      setDdlStds(std.data);

      const year_result = await axios.get(`${BASE_URL}/api/ddl_years`);
      setDdlAcademicYears(year_result.data);


    } catch (err) {
      console.error(err);
    }

  };

  // Fetch report
  const handleRunReport = async () => {

    try {

      setReportData([]);

      const res = await axios.get(`${BASE_URL}/api/rpt_fw_listing`);

      if (res.data.length > 0) {
        setReportData(groupData(res.data));
      } else {
        setReportData([]);
        toast.error("No Records Found");
      }

    } catch (err) {
      console.error("Report Error:", err);
      toast.error("Error loading Report.");
    }

  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" }); // Jan, Feb, etc.
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const formatDateForFile = (dateStr) => {
    const [year, month, day] = dateStr.split("-"); // safest approach
    return `${day}-${month}-${year}`;
  };

  /// Grouping Data on mst_fee_waivers
  const groupData = (data) => {

    const grouped = {};

    data.forEach((item) => {

      const key = item.fw_desc + "|" +
                  item.yrly_perm + "|" +
                  item.mthly_install + "|" +
                  item.fw_catg + "|" +
                  item.bgt_name + "|" +
                  item.sub_bgt_name + "|" +
                  item.fw_status;

      if (!grouped[key]) {
        grouped[key] = {
          fw_desc: item.fw_desc,
          yrly_perm: item.yrly_perm,
          mthly_install: item.mthly_install,
          fw_catg: item.fw_catg,
          bgt_name: item.bgt_name,
          sub_bgt_name: item.sub_bgt_name,
          fw_status: item.fw_status,
          details: []
        };
      }

      grouped[key].details.push({
        fee_desc: item.fee_desc,
        fw_perc: item.fw_perc,
        fw_inst1: item.fw_inst1,
        fw_inst2: item.fw_inst2,
        fw_inst3: item.fw_inst3,
        fw_inst4: item.fw_inst4,
        fw_inst5: item.fw_inst5,
        fw_inst6: item.fw_inst6
      });

    });

    return Object.values(grouped);
  };

  ///// Start : PDF Download
  const handleDownloadPDF = () => {

    if (reportData.length === 0) {
      toast.warning("No data to download");
      return;
    }

    downloadFW_ListingPDF({
        reportData,
    });

  };
  //// End Pdf download

  return (

    <Container fluid className="p-3">

      {/* Filters */}
      <Card className="p-3 mb-3">
        <Row>

          <Col md={12} className="d-flex justify-content-end">
            <Button variant="primary" className="ms-2"
              disabled={reportData.length === 0} onClick={handleDownloadPDF}
               > Download PDF
            </Button>
            <Button variant="success" onClick={handleRunReport} className="ms-2">
              Run Report
            </Button>          
          </Col>
        </Row>

      </Card>

      {/* Report Table */}

      <Card className="p-3">
        <div className="table-responsive" style={{ minHeight: "220px" }}>

          <table className="responsive-table scty-custom-table-rcpt hover-table-rcpt"
            style={{ width: "100%", tableLayout: "fixed", borderCollapse: "collapse" }} >

            <colgroup>

              <col style={{ width: "37%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "9%" }} />
              <col style={{ width: "9%" }} />

            </colgroup>

            <tbody>

              {reportData.length > 0 ? (

                reportData.map((group, index) => (

                  <React.Fragment key={index}>

                    {/* GROUP HEADER */}

                    <tr style={{ backgroundColor: "#d9edf7" }}>

                      <td colSpan={8} style={{ padding: "8px" }}>

                        <Row className="mb-2 mt-1">
                          <Col md={1}><b>Fee Waiver :</b></Col>
                          <Col md={3}>{group.fw_desc}</Col>
                          <Col md={1}><b>Yearly :</b></Col>
                          <Col md={1}>{group.yrly_perm}</Col>
                          <Col md={1}><b>Monthly :</b></Col>
                          <Col md={1}>{group.mthly_install}</Col>
                          <Col md={1}><b>Status :</b></Col>
                          <Col md={1}>{group.fw_status}</Col>
                        </Row>

                        <Row>
                          <Col md={1}><b>Category :</b></Col>
                          <Col md={3}>{group.fw_catg}</Col>
                          <Col md={1}><b>Budget :</b></Col>
                          <Col md={3}>{group.bgt_name}</Col>
                          <Col md={1}><b>Sub Budget :</b></Col>
                          <Col md={3}>{group.sub_bgt_name}</Col>
                        </Row>

                      </td>

                    </tr>

                    {/* SUB HEADER */}

                    <tr className="table-secondary">

                      <th style={{ textAlign: "left" }}>Fee Components </th>
                      <th style={{ textAlign: "right" }}>Waiver % </th>
                      <th style={{ textAlign: "right" }}>Installment-1 %</th>
                      <th style={{ textAlign: "right" }}>Installment-2 %</th>
                      <th style={{ textAlign: "right" }}>Installment-3 %</th>
                      <th style={{ textAlign: "right" }}>Installment-4 %</th>
                      <th style={{ textAlign: "right" }}>Installment-5 %</th>
                      <th style={{ textAlign: "right" }}>Installment-6 %</th>

                    </tr>

                    {/* DETAILS */}

                    {group.details.map((d, i) => (

                      <tr key={i}>

                        <td style={{ textAlign: "left" }}>{d.fee_desc}</td>
                        <td style={{ textAlign: "right" }}>{d.fw_perc}</td>
                        <td style={{ textAlign: "right" }}>{d.fw_inst1}</td>
                        <td style={{ textAlign: "right" }}>{d.fw_inst2}</td>
                        <td style={{ textAlign: "right" }}>{d.fw_inst3}</td>
                        <td style={{ textAlign: "right" }}>{d.fw_inst4}</td>
                        <td style={{ textAlign: "right" }}>{d.fw_inst5}</td>
                        <td style={{ textAlign: "right" }}>{d.fw_inst6}</td>

                      </tr>

                    ))}

                    <tr>
                      <td
                        colSpan={8}
                        style={{
                          height: "15px",
                          border: "none",
                          background: "#fff"
                        }}
                      ></td>
                    </tr>

                  </React.Fragment>

                ))

              ) : (

                <tr>
                  <td colSpan={8} className="text-center">
                    No Records Found
                  </td>
                </tr>

              )}

            </tbody>

          </table>

        </div>
      </Card>

    </Container>
  );
};

export default Rpt_FeeWaiverListing;
